/* eslint-disable */
import { fromJS, List, Map } from "immutable";
import { Configurer } from "../App";
import * as selectors from "./selectors";
import moment from "moment";
import { name } from "./__init__";
import constants from "../../utils/constants";

import {
  saveToSessionStorage,
  removeFromSessionStorage,
  saveReservationToStorage,
} from "../../utils/misc";
import { name as appName } from "../App/__init__";

const CREATE_RESERVATION = `${name}/CREATE_RESERVATION`;
const CREATE_RESERVATION_SUCCESS = `${name}/CREATE_RESERVATION_SUCCESS`;
const CREATE_RESERVATION_ERROR = `${name}/CREATE_RESERVATION_ERROR`;

const LOAD_RESERVATION_ARI = `${name}/LOAD_RESERVATION_ARI`;
const LOAD_RESERVATION_ARI_SUCCESS = `${name}/LOAD_RESERVATION_ARI_SUCCESS`;
const LOAD_RESERVATION_ARI_ERROR = `${name}/LOAD_RESERVATION_ARI_ERROR`;

const STORE_RESERVATION_ARI = `${name}/STORE_RESERVATION_ARI`;

const CLEAR_RESERVATION_ARI = `${name}/CLEAR_RESERVATION_ARI`;

const UPDATE_RESERVATIONS = `${name}/UPDATE_RESERVATIONS`;

const NOTIFY_INVALID_RESERVATIONS = `${name}/NOTIFY_INVALID_RESERVATIONS`;
const NOTIFY_INVALID_PAYMENTS = `${name}/NOTIFY_INVALID_PAYMENTS`;

const CLEAR_DATA = "CLEAR_DATA";

const REMOVE_RESERVATION = `${name}/REMOVE_RESERVATION`;

const ADD_SERVICE_TO_RESERVATION = `${name}/ADD_SERVICE_TO_RESERVATION`;

const CHANGE_RESERVATION_ROOM_STAY_NUMBER_OF_UNITS = `${name}/CHANGE_RESERVATION_ROOM_STAY_QUANTITY`;

const CHANGE_PAYMENT_TYPE = `${name}/CHANGE_PAYMENT_TYPE`;

const SET_PAYMENT_TYPES = `${name}/SET_PAYMENT_TYPES`;

const SET_SMART_PAYMENT_AVAILABLE_PAYMENTS = `${name}/SET_SMART_PAYMENT_AVAILABLE_PAYMENTS`;

export const initialState = fromJS({
  reservationARIMap: false,
  reservations: false,
  paymentTypes: false,
});

export function getPaymentTypes(reservations) {
  let paymentTypes = new Map();
  reservations.map((reservationList, ticker) => {
    let intersection = new List();
    reservationList.map(reservation => {
      if (intersection.size === 0) {
        intersection = reservation
          .get("paymentTypes")
          .filter(element => Object.keys(constants.PAYMENT_TYPES).indexOf(element) > -1)
          .toSet();
      } else {
        intersection = reservation.get("paymentTypes").toSet().intersect(intersection);
      }
    });
    paymentTypes = paymentTypes.set(ticker, intersection.toList());
  });

  return paymentTypes;
}

export default (state = initialState, action) => {
  switch (action.type) {
    case STORE_RESERVATION_ARI: {
      return state.set("reservationARIMap", action.reservationARIMap);
    }
    case UPDATE_RESERVATIONS:
      /* RETRIEVED FROM LOCAL STORAGE / MULTIPLE RESERVATIONS */
      if (action.reservationARI) {
        const reservationARIMap = state.get("reservationARIMap") || new Map();
        state = state.set("reservationARIMap", reservationARIMap.merge(action.reservationARI));
      }
      if (action.reservations) {
        saveReservationToStorage(
          constants.LOCAL_STORAGE_KEYS.CART,
          action.reservations && action.reservations.toJS()
        );
        const paymentTypes = getPaymentTypes(action.reservations);
        const paymentTypesMap = new Map().set("available", paymentTypes);
        return state.set("reservations", action.reservations).set("paymentTypes", paymentTypesMap);
      }
      if (action.reservation) {
        let reservations = state.get("reservations") || new Map();
        if (!reservations.has(action.propertyTicker)) {
          reservations = reservations.set(action.propertyTicker, new List());
        }
        /*TODO: search reservation list for one that has the same ticker and delete it */
        reservations = reservations.set(
          action.propertyTicker,
          reservations.get(action.propertyTicker).push(action.reservation)
        );
        saveReservationToStorage(
          constants.LOCAL_STORAGE_KEYS.CART,
          reservations && reservations.toJS()
        );
        const paymentTypes = getPaymentTypes(reservations);
        const paymentTypesMap = new Map().set("available", paymentTypes);
        return state.set("reservations", reservations).set("paymentTypes", paymentTypesMap);
      }
      return state;
    case NOTIFY_INVALID_RESERVATIONS:
      // when action object has invalid reservations,
      // it is passed to the state and an alert must be shown to the user
      return state.set("invalidReservations", fromJS(action.invalidReservations) || null);
    case NOTIFY_INVALID_PAYMENTS:
      // when action object has invalid payments,
      // it is passed to the state and an alert must be shown to the user
      return state.set("invalidPayments", action.value);
    case CLEAR_DATA:
      removeFromSessionStorage(constants.LOCAL_STORAGE_KEYS.CART);
      removeFromSessionStorage(constants.LOCAL_STORAGE_KEYS.HEARTBEAT_LOYALTY_DATA);
      removeFromSessionStorage(constants.LOCAL_STORAGE_KEYS.HEARTBEAT_LAST_BOOKING_CART_DATA);

      return state
        .set("reservations", false)
        .set("paymentTypes", false)
        .set("invalidReservations", false)
        .set("reservationARIMap", false);
    case REMOVE_RESERVATION: {
      let reservations = state.get("reservations");
      if (reservations && reservations.has(action.propertyTicker)) {
        reservations = reservations.set(
          action.propertyTicker,
          reservations
            .get(action.propertyTicker)
            .filter(reservation => reservation.get("id") !== action.id)
        );
      }
      saveReservationToStorage(constants.LOCAL_STORAGE_KEYS.CART, reservations.toJS());
      return state.set("reservations", reservations);
    }
    case CHANGE_RESERVATION_ROOM_STAY_NUMBER_OF_UNITS: {
      // when action object has invalid reservations,
      // it is passed to the state and an alert must be shown to the user
      let reservations = state.get("reservations");
      if (!reservations.has(action.propertyTicker)) {
        return state;
      }

      reservations = reservations.set(
        action.propertyTicker,
        reservations.get(action.propertyTicker).update(
          reservations
            .get(action.propertyTicker)
            .findIndex(reservation => reservation.get("id") === action.reservationId),
          reservation => {
            if (action.numberOfUnits <= 0) {
              return;
            }
            return reservation.setIn(["numberOfUnits"], action.numberOfUnits);
          }
        )
      );

      saveReservationToStorage(constants.LOCAL_STORAGE_KEYS.CART, reservations.toJS());
      return state.set("reservations", reservations);
    }
    case ADD_SERVICE_TO_RESERVATION: {
      // when action object has invalid reservations,
      // it is passed to the state and an alert must be shown to the user
      let reservations = state.get("reservations");
      if (!reservations.has(action.propertyTicker)) {
        return state;
      }
      reservations = reservations.set(
        action.propertyTicker,
        reservations.get(action.propertyTicker).update(
          reservations
            .get(action.propertyTicker)
            .findIndex(reservation => reservation.get("id") === action.reservationId),
          reservation => {
            let newReservation = reservation;
            Object.keys(action.quantity).map(extraTicker => {
              const quantity = action.quantity[extraTicker];
              const showedQuantity = action.showedQuantity[extraTicker];

              newReservation = quantity
                ? newReservation
                    .setIn(["selectedServices", extraTicker, "dateQuantity"], quantity)
                    .setIn(["selectedServices", extraTicker, "showedQuantity"], showedQuantity)
                : newReservation.deleteIn(["selectedServices", extraTicker]);

              if (action.forms[extraTicker]) {
                Object.keys(action.forms[extraTicker]).forEach(fieldName => {
                  // If action value is empty, delete the key where it's stored in map
                  if (!!action.forms[extraTicker][fieldName]) {
                    newReservation = newReservation.setIn(
                      ["selectedServices", extraTicker, "formValues", fieldName],
                      action.forms[extraTicker][fieldName]
                    );
                  } else {
                    newReservation = newReservation.deleteIn([
                      "selectedServices",
                      extraTicker,
                      "formValues",
                      fieldName,
                    ]);
                  }
                  // If formValues map doesn't have any entries, delete it
                  if (
                    newReservation.getIn(["selectedServices", extraTicker, "formValues"]).size === 0
                  ) {
                    newReservation = newReservation.deleteIn([
                      "selectedServices",
                      extraTicker,
                      "formValues",
                    ]);
                  }
                });
              }
            });
            return newReservation;
          }
        )
      );

      saveReservationToStorage(constants.LOCAL_STORAGE_KEYS.CART, reservations.toJS());
      return state.set("reservations", reservations);
    }
    case CHANGE_PAYMENT_TYPE:
      return state.set(
        "paymentTypes",
        state.get("paymentTypes").setIn(["selected", action.propertyTicker], action.paymentType)
      );
    case SET_PAYMENT_TYPES:
      const paymentTypes = action.paymentTypes;
      const paymentTypesMap = new Map().set("available", paymentTypes);
      return state.set("paymentTypes", paymentTypesMap);

    case SET_SMART_PAYMENT_AVAILABLE_PAYMENTS:
      const availablePayments = action.availablePayments;
      return state.set("smartPaymentAvailablePayments", availablePayments);
    default:
      return state;
  }
};

export function isReservationARILoaded(globalState) {
  return globalState[name] && globalState[name].get("reservationARI");
}

function areEquals({ actualReservation, pastReservation, inventoryRelations }) {
  const currentParent = inventoryRelations.parents[actualReservation.inventory];
  const pastParent = inventoryRelations.parents[pastReservation.inventory];
  return currentParent === pastParent;
}

function datesIntersect(actualReservation, pastReservation) {
  return (
    new Date(actualReservation.startDate) < new Date(pastReservation.endDate) &&
    new Date(actualReservation.endDate) > new Date(pastReservation.startDate)
  );
}

const isReservationValid = ({ reservation, arivalues, reservationsProcessed = [], areSisters }) => {
  /* Check if start and end dates are valid */
  const reservationStart = moment(reservation.startDate).endOf("day").toDate();
  const reservationEnd = moment(reservation.endDate).endOf("day").toDate();
  const today = moment(new Date()).startOf("day").toDate();
  if (reservationStart < today || reservationEnd < moment(today).add(1, "days")) {
    return false;
  }

  /* Check if inventory is restricted or soldout */
  const inventoryARI = arivalues[reservation.inventory];
  const status =
    (inventoryARI && inventoryARI.lastStatus.code) || constants.BOOKABLE_STATUS.UNAVAILABLE;
  if (status !== constants.BOOKABLE_STATUS.AVAILABLE) {
    return false;
  }
  let inventoryAvailability = parseFloat(inventoryARI.availability);

  reservationsProcessed.forEach(res => {
    if (areSisters(reservation, res) && datesIntersect(reservation, res)) {
      inventoryAvailability -= res.numberOfUnits;
    }
  });

  const numberOfUnits = parseInt(reservation.numberOfUnits, 10);

  /* Check if there's enough availability */
  if (inventoryAvailability >= 1) {
    const remainingAvailability = inventoryAvailability - numberOfUnits;
    const isValid = remainingAvailability >= 0;
    if (isValid) {
      reservationsProcessed.push(reservation);
    }
    return isValid;
  }

  return false;
};

export function requestReservationARI({
  reservations,
  locale,
  promoCodes,
  deviceInfo,
  currency,
  ipInfo,
  sessionId,
}) {
  const totalAmount = reservations.reduce(
    (accumulator, reservation) => accumulator + reservation.totalRate * reservation.numberOfUnits,
    0
  );
  return Promise.all(
    reservations.map(reservation => {
      return Configurer.fetchARI(reservation.propertyTicker, {
        start: reservation.startDate,
        end: reservation.endDate,
        inventoryTickersEqualFilter: [reservation.inventory],
        ignoredConfiguration: true,
        promoCodes,
        locale,
        deviceInfo,
        ipInfo,
        totalAmount: {
          value: {
            amount: totalAmount,
            currency,
          },
        },
        reservationAmount: {
          value: {
            amount: reservation.totalRate * reservation.numberOfUnits,
            currency,
          },
        },
        sessionId,
      });
    })
  ).then(reservationARIs => {
    const reservationARIMap = reservations.reduce((accumulator, reservation, idx) => {
      accumulator[reservation.id] = reservationARIs[idx];
      return accumulator;
    }, {});
    return reservationARIMap;
  });
}

export function storeReservationARI({ reservationARIMap }) {
  return {
    type: STORE_RESERVATION_ARI,
    reservationARIMap,
  };
}

export function updateReservations({ reservations, reservation, propertyTicker, reservationARI }) {
  return {
    type: UPDATE_RESERVATIONS,
    reservations,
    reservation,
    propertyTicker,
    reservationARI,
  };
}

export function notifyInvalidReservations({ invalidReservations }) {
  return {
    type: NOTIFY_INVALID_RESERVATIONS,
    invalidReservations,
  };
}

export function notifyInvalidPayments({ reservations, value }) {
  return {
    type: NOTIFY_INVALID_PAYMENTS,
    reservations,
    value,
  };
}

export function clearCartData() {
  return {
    type: CLEAR_DATA,
  };
}
const getInvalidReservations = ({ reservations, reservationARIMap, areSisters }) => {
  const reservationsProcessed = [];
  return reservations
    .map(reservation => {
      const reservationARI = reservationARIMap[reservation.id];
      const arivalues = reservationARI[reservation.propertyTicker].arivalues;
      if (!isReservationValid({ reservation, arivalues, reservationsProcessed, areSisters })) {
        return reservation.id;
      }
      return null;
    })
    .filter(id => id !== null);
};

export function validateReservations({ reservations, locale, propertyTicker, sessionId }) {
  return (dispatch, getState) => {
    const configuration = getState()[appName].get("configuration").toJS();
    const inventoryRelations = getState()[appName].get("propertyData").toJS()[propertyTicker]
      .inventoryRelations;
    const areSistersCurried = (actualReservation, pastReservation) =>
      areEquals({ actualReservation, pastReservation, inventoryRelations });
    const promoCodes = (configuration.promoCodes && configuration.promoCodes.split(",")) || null;
    const deviceInfo = configuration.deviceInfo || {};
    requestReservationARI({
      reservations,
      dispatch,
      locale,
      promoCodes,
      deviceInfo,
      currency: configuration.currency,
      ipInfo: configuration.ipInfo,
      sessionId,
    })
      .then(reservationARIMap => {
        /* Store Reservation ARI for CHECKOUT Calculations */
        dispatch(storeReservationARI({ reservationARIMap: fromJS(reservationARIMap) }));
        /* Determine Invalid Reservations  */
        return getInvalidReservations({
          reservations,
          reservationARIMap,
          areSisters: areSistersCurried,
        });
      })
      .then(invalidReservationsIDs => {
        /* Filter out invalid reservations */
        const validReservations =
          reservations.filter(
            reservation => invalidReservationsIDs.indexOf(reservation.id) === -1
          ) || [];
        const invalidReservations =
          reservations.filter(
            reservation => invalidReservationsIDs.indexOf(reservation.id) !== -1
          ) || [];
        /* Update reservations with only the valid ones*/
        dispatch(notifyInvalidReservations({ invalidReservations: fromJS(invalidReservations) }));
        /* Update reservations with only the valid ones*/
        dispatch(
          updateReservations({
            reservations: fromJS({ [propertyTicker]: validReservations }),
          })
        );
      });
  };
}

export function updateReservationARI({ reservations, locale, sessionId }) {
  return (dispatch, getState) => {
    const configuration = getState()[appName].get("configuration").toJS();
    const promoCodes = (configuration.promoCodes && configuration.promoCodes.split(",")) || null;
    const deviceInfo = configuration.deviceInfo || {};
    requestReservationARI({
      reservations,
      dispatch,
      locale,
      promoCodes,
      deviceInfo,
      currency: configuration.currency,
      ipInfo: configuration.ipInfo,
      sessionId,
    }).then(reservationARIMap => {
      /* Store Reservation ARI for CHECKOUT Calculations */
      dispatch(storeReservationARI({ reservationARIMap: fromJS(reservationARIMap) }));
    });
  };
}

export function addReservation(propertyTicker, reservation, reservationARI) {
  /* TODO: CHECK IF RESERVATIONS ARE VALID ACCORDING TO AVAILABILITY, IF NOT DENY THEM*/
  /* TODO: THIS MUST BE INVOKED AT APP INITIALIZATION RECOVER THEM IN SAGAS, IT"S PART OF THE CONFIG*/
  return (dispatch, getState) => {
    const reservations =
      (getState()[name].get("reservations") &&
        getState()
          [name].get("reservations")
          .setIn(
            [propertyTicker],
            (getState()[name].get("reservations").get(propertyTicker) &&
              getState()[name].get("reservations").get(propertyTicker).push(reservation)) ||
              new List().push(reservation)
          )) ||
      new Map().setIn([propertyTicker], new List().push(reservation));
    const paymentTypes = getPaymentTypes(reservations);
    if (paymentTypes.get(propertyTicker).size === 0) {
      return dispatch(notifyInvalidPayments({ reservations, value: true }));
    } else {
      return dispatch(
        updateReservations({
          reservation,
          propertyTicker,
          reservationARI,
        })
      );
    }
  };
}

export function removeReservation({ id, propertyTicker }) {
  return {
    type: REMOVE_RESERVATION,
    id,
    propertyTicker,
  };
}

export function changePaymentType({ paymentType, propertyTicker }) {
  return {
    type: CHANGE_PAYMENT_TYPE,
    paymentType,
    propertyTicker,
  };
}

export function setPaymentTypes(paymentTypes) {
  return {
    type: SET_PAYMENT_TYPES,
    paymentTypes,
  };
}

export function addServiceToReservation({
  reservationId,
  propertyTicker,
  quantity,
  showedQuantity,
  forms,
  dates,
}) {
  return {
    type: ADD_SERVICE_TO_RESERVATION,
    reservationId,
    propertyTicker,
    quantity,
    showedQuantity,
    forms,
    dates,
  };
}

export function changeReservationRoomStayNumberOfUnits({
  reservationId,
  propertyTicker,
  numberOfUnits,
}) {
  return {
    type: CHANGE_RESERVATION_ROOM_STAY_NUMBER_OF_UNITS,
    reservationId,
    numberOfUnits,
    propertyTicker,
  };
}

export function setSmartPaymentAvailablePayments(availablePayments) {
  return {
    type: SET_SMART_PAYMENT_AVAILABLE_PAYMENTS,
    availablePayments,
  };
}

export const actions = {
  validateReservations,
  addReservation,
  updateReservationARI,
  removeReservation,
  changePaymentType,
  notifyInvalidReservations,
  notifyInvalidPayments,
  addServiceToReservation,
  changeReservationRoomStayNumberOfUnits,
  clearCartData,
  setSmartPaymentAvailablePayments,
};
